import moment from "moment";
import sprintf from "sprintf";
import some from "lodash/some";
import forEach from "lodash/forEach";
import map from "lodash/map";
import isArray from "lodash/isArray";
import isString from "lodash/isString";
import template from "lodash/template";

import "calendar";

import general from "general";
import storage from "general/poly/storage";
import generateTimeSlotRequestData from "general/functions/generateTimeSlotRequestData";

const $window = $(window);
const pageData = document.querySelector("#page-data");
const patientGroup = pageData.dataset.patientGroup;

$.fn.calendar.cloneTo("generalCalendar");
// Configure defaults
$.fn.generalCalendar.updateDefaultsWith({
  first_day: 1,
  practitionerIds: null,
  workplaceId: null,
  reasonForVisitId: null,
  tmpl_path: function(path) {
    return general.getStaticPath("templates/calendar/") + path + ".html";
  },
  tmpl_cache: false,
  templates: {
    day: require("templates/calendar/day.html"),
    error: require("templates/calendar/error.html"),
    event: require("templates/calendar/event.html"),
    header: require("templates/calendar/header.html"),
    week: require("templates/calendar/week.html"),
    "week-days": require("templates/calendar/week-days.html"),
    loading: require("templates/calendar/loading.html"),
    init: require("templates/calendar/init.html"),
  },
  holidays: {},
  view: "week",
  views: {
    year: { enable: 0 },
    month: { enable: 0 },
  },
  reasonStorageKey: "reason_for_visit_id",
  reasonInTimeslots: true,
  maxVehiclesAllowed: 0,
  vehicleQuantity: 0,
  vehicleQuantitySelector: "#vehicle_quantity_select",
});

// Extend with custom members
$.fn.generalCalendar.extendMembersWith({
  // NOTE(jan): This is here because the templates receive 'this' and some of
  // them need each and / or moment.
  each: forEach,
  forEach,
  // NOTE(jan): This is here because the templates receive 'this' and some of
  // them need each and / or moment.
  moment,
  timeslotTopDelta: 0,
  init: function(_super) {
    this.options.view = $window.width() < 768 ? "day" : "week";
    this.headerContext = this.context.find(".calendar__container__controls");
    this.contentContext = this.context.find(".calendar__container__content");
    this.options.reasonForVisitId = storage.sessionStorage.getItem(
      this.options.reasonStorageKey
    );
    this.patientView = !!document.querySelector("#booking-calendar");

    this.reasonForce =
      document.querySelector("#page-data").dataset.reasonForce === "true" ||
      (this.patientView &&
        document.querySelector("#booking-calendar").dataset.reasonForce ===
          "true");

    if (this.patientView) {
      if (
        document.querySelector("#booking-calendar").dataset.reasonInTimeslots
      ) {
        this.options.reasonInTimeslots =
          document.querySelector("#booking-calendar").dataset
            .reasonInTimeslots === "true";
      }
    }

    this.options.reasonLabel = "an Appointment Reason";
    if (
      this.patientView &&
      !!document.querySelector("#booking-calendar").dataset.reasonLabel
    ) {
      this.options.reasonLabel = document.querySelector("#booking-calendar").dataset
        .reasonLabel;
    }

    this._loadReasons().then(function() {
      _super();
    });

    let resizeTimer;
    $window.resize((e) => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.view($window.width() < 768 ? "day" : "week");
      }, 250);
    });
  },
  /**
   * Given an Event object, render it using the Event template.
   *
   * This method is used internally by the day and week-days templates in order to ensure that the structure of
   * the output associated with Events is consistent regardless of the Calendar view.
   *
   * @param {Object} event
   * @returns {string}
   * @private
   */
  _event: function(event) {
    this._loadTemplate("event");
    return this.options.templates["event"]({
      event: event,
      cal: this,
    });
  },
  /**
   * Given a TimeSlot object, render it using the TimeSlot template.
   *
   * This method is used internally by the event template in order to
   * ensure that the structure of the output associated with Events
   * is consistent regardless of the Calendar view.
   *
   * @param {Object} timeSlot
   * @returns {string}
   * @private
   */
  _timeSlot: function(timeSlot, timeSlotMinute) {
    this._loadTemplate("timeSlot");
    return this.options.templates["timeSlot"]({
      timeSlot: timeSlot,
      timeSlotMinute: timeSlotMinute,
      cal: this,
    });
  },
  /**
   *
   * @param {string} [view]
   * @param {boolean} [renderHeader=true]
   * @param {boolean} [renderContent=true]
   */
  view: function(view, renderHeader = true, renderContent = true) {
    var storedContext = this.context;

    if (view) {
      if (!this.options.views[view].enable) {
        return;
      }
      this.options.view = view;
    }

    this._init_position();

    if (renderHeader) {
      this._renderHeader();
      this._updateHeader();
    }

    function _loadAndRender(self) {
      let spinner = document.querySelector(".calendar__container__content");
      spinner.classList.add("spinner");
      if (self.patientView) {
        self.contentContext.html(self.options.templates.loading());
        if (
          self.options.maxVehiclesAllowed > 0 &&
          self.options.vehicleQuantity < 1
        ) {
          spinner.classList.remove("spinner");
          self.contentContext.empty();
        }
      }

      if (
        self.options.maxVehiclesAllowed > 0 &&
        self.options.vehicleQuantity < 1
      ) {
        // Do not load timeslots until a vehicle quantity has been
        // selected when there is a valid max quantity allowed
      } else {
        self._loadEvents().then(function() {
          spinner.classList.remove("spinner");
          if (self.options.events.length === 0) {
            self._renderError();
            return;
          }

          if (renderContent) {
            self.context = self.contentContext;
            self._render();
            self.context = storedContext;
          }

          self.options.onAfterViewLoad.call(self, self.options.view);
        });
      }
    }

    if (this.reasonForce) {
      if (this.options.reasonForVisitId) {
        _loadAndRender(this);
      } else {
        this._renderReasonRequired();
      }
    } else {
      _loadAndRender(this);
    }

    this.options.onAfterViewLoad.call(this, this.options.view);
  },
  /**
   * Renders the Header template
   *
   * @private
   */
  _renderHeader: function() {
    this._loadTemplate("header");
    this.headerContext.empty().html(
      this.options.templates["header"]({
        start: parseInt(this.options.position.start.getTime()),
        end: parseInt(this.options.position.end.getTime()),
        cal: this,
        useReasons: $("span#features").data("reasons"),
        reasons: this.options.reasons,
        reasonLabel: this.options.reasonLabel,
        isReasonSelected: this.options.reasonForVisitId || this.options.reasons.length == 1,
        reasonForce: this.reasonForce
      })
    );
    var reasonSelect = this.headerContext.find("#reason_select");
    var self = this;
    if (self.options.reasons.length == 1) {
      self.options.reasonForVisitId =
        self.options.reasons[0].reason_for_visit.id;
      storage.sessionStorage.setItem(
        self.options.reasonStorageKey,
        self.options.reasonForVisitId
      );
    }
    reasonSelect.on("change", async (e) => {
      self.options.reasonForVisitId = reasonSelect.val();
      storage.sessionStorage.setItem(
        self.options.reasonStorageKey,
        self.options.reasonForVisitId
      );
      self.options.vehicleQuantity = 0;

      if (self.reasonForce) {
        if (self.options.reasonForVisitId) {
          await self.view();
        } else {
          self._renderHeader()
          self._updateHeader()
          self._renderReasonRequired();

        }
      } else {
        await self.view();
      }
    });

    const vehiclesSelect = this.headerContext.find(
      self.options.vehicleQuantitySelector
    );
    vehiclesSelect.on("change", async (e) => {
      self.options.vehicleQuantity = parseInt(vehiclesSelect.val()) || 0;
      await self.view();
    });
  },

  _renderReasonRequired: function() {
    const reasonSelect = this.headerContext.find("#reason_select");
    const vehiclesSelect = this.headerContext.find(
      this.options.vehicleQuantitySelector
    );
    vehiclesSelect.css('display', 'none');

    this.contentContext.empty().html(this.options.templates.init({
      reasonLabel: this.options.reasonLabel,
    }));
  },
  /**
   * Renders the error template in place of any timeslots
   * @private
   */
  _renderError: function() {
    this._loadTemplate("error");
    this.contentContext.empty().html(this.options.templates.error());
    this.context.find(".cal--error a").click((e) => {
      general.callApi(
        this._generateRequestPath(moment(), moment().add(1, "year"), true),
        "GET",
        { limit: 1, expand: true },
        null,
        (result) => {
          var day = "now";
          if (result && result.objects && result.objects.length >= 1) {
            day = result.objects[0].date;
          }
          this.options.day = day;
          this.view();
        }
      );
      return false;
    });
  },
  /**
   * Binds events handlers associated with the Header. Only called if the Header template was (re)rendered.
   * @private
   */
  _updateHeader: function() {
    var self = this,
      weekSelect = this.headerContext.find(".no-select.week"),
      reasonSelect = this.headerContext.find("#reason_select"),
      vehiclesSelect = this.headerContext.find(
        self.options.vehicleQuantitySelector
      );

    this.headerContext.find(".gp-calendar__arrow").click(function(event) {
      var arrow = $(this),
        direction = arrow.data("direction"),
        date = arrow.data("date");
      if (weekSelect.parent(":visible").length) {
        self.options.day = date;
        self.view("week");
      } else {
        self.navigate(direction);
      }
    });

    weekSelect.change(function() {
      self.options.day = weekSelect.val();
      self.view("week");
    });

    if (this.options.reasons) {
      reasonSelect.children("option:not(:first)").remove();
      forEach(this.options.reasons, (reason) => {
        let displayText = reason.reason_for_visit.reason_display;
        if (reason.rate && reason.rate !== "0.00") {
          displayText = displayText + ` (R${reason.rate})`;
        }
        reasonSelect.append(
          $("<option></option>")
            .attr("value", reason.reason_for_visit.id)
            .text(displayText)
            .attr("data-reason", reason.reason_for_visit.reason_display)
            .attr("data-id", reason.reason_for_visit.id)
            .attr("data-rate", reason.rate && reason.rate !== "0.00")
        );
      });
      var value =
        this.options.reasonForVisitId ||
        storage.sessionStorage.getItem(this.options.reasonStorageKey);
      this.headerContext.find("#reason_select").val(value);

      // Populate the vehicle quantity dropdown and toggle visibility
      const rfv = this.options.reasons.find(
        (r) => r.reason_for_visit.id == value
      );
      this.options.maxVehiclesAllowed =
        rfv && rfv.meta_data ? rfv.meta_data.maxVehiclesAllowed : 0;

      if (value && this.options.maxVehiclesAllowed > 0) {
        vehiclesSelect.children("option:not(:first)").remove();
        for (let i = 1; i <= this.options.maxVehiclesAllowed; i++) {
          vehiclesSelect.append(
            $("<option></option>")
              .attr("value", i)
              .text(`${i} Vehicle${i > 1 ? "s" : ""}`)
          );
        }

        if (this.options.maxVehiclesAllowed == 1) {
          this.options.vehicleQuantity = 1;
          vehiclesSelect.css('display', 'none');
        } else {
          vehiclesSelect.css('display', 'block');
        }

        if (this.options.vehicleQuantity) {
          this.headerContext
            .find(self.options.vehicleQuantitySelector)
            .val(this.options.vehicleQuantity);
        }
      } else {
        vehiclesSelect.css('display', 'none');
      }
    } else {
      reasonSelect.css('display', 'none');
      vehiclesSelect.css('display', 'none');
    }
  },
  /**
   * Generates a object that can be used to make a request from the DynamicTimeSlotResource or Appointment Resources
   *
   * @param {string} startDate
   * @param {string} endDate
   * @param {boolean} [futureOnly]
   * @returns {Object}
   * @private
   */
  _generateRequestDataForLoadTimeSlots: function(
    startDate,
    endDate,
    futureOnly
  ) {
    return generateTimeSlotRequestData(
      isArray(this.options.practitionerIds)
        ? this.options.practitionerIds.join(",")
        : this.options.practitionerIds,
      this.options.workplaceId,
      startDate,
      endDate,
      futureOnly
    );
  },
  /**
   * Generates a request path string that be used with general.callApi to
   * make a request against the DynamicTimeSlotResource
   *
   * @param {string|Moment} startDate
   * @param {string|Moment} endDate
   * @param {boolean} [futureOnly]
   * @returns {string}
   * @private
   */
  _generateRequestPath(startDate, endDate, futureOnly) {
    let requestData = this._generateRequestDataForLoadTimeSlots(
        startDate,
        endDate,
        futureOnly
      ),
      requestComponents = [
        "workplace",
        requestData.workplace_id,
        "dynamic_time_slot",
      ],
      requestParamsComponents = [];
    if (isString(requestData.practitioner_id)) {
      requestComponents.push("practitioners", requestData.practitioner_id);
    }
    requestComponents.push(
      "from",
      requestData.start_datetime,
      "to",
      requestData.end_datetime,
      "future-only",
      requestData.future_only
    );
    if (this.options.vehicleQuantity > 0) {
      requestParamsComponents.push(
        `vehicle_quantity=${this.options.vehicleQuantity}`
      );
    }
    if (this.options.reasonForVisitId && this.options.reasonInTimeslots) {
      requestParamsComponents.push(
        `reason_for_visit_id=${this.options.reasonForVisitId}`,
        `brand=${patientGroup}`
      );
    }
    const queryParams = "?" + requestParamsComponents.join("&");
    return requestComponents.join("/") + "/" + queryParams;
  },
  _loadTemplate: $.noop,
  /* NOTE(jan): NO OP. Templates are loaded via webpack.
           To restore the normal way of template loading, remove this function
           and the webpack code. */
  /**
   * Loads TimeSlots using the Recomed API DynamicTimeSlotResource
   *
   * @param {string} startDate
   * @param {string} endDate
   * @param {boolean} [futureOnly]
   * @returns {Array}
   * @private
   */
  _loadTimeSlots: function loadTimeslots(startDate, endDate, futureOnly) {
    return new Promise((resolve, reject) => {
      general
        .callApi(
          this._generateRequestPath(startDate, endDate, futureOnly),
          "GET",
          { expand: true },
          {
            404: () => {
              resolve([]);
            },
          },
        )
        .done(function (result) {
          let timeSlots = [];
          forEach(result.objects || [], function (timeSlot, index) {
            let start = moment(
                timeSlot.date + timeSlot.time,
                "YYYY-MM-DDHH:mm:ss",
              ),
              startHour = start.format("HH:mm"),
              end = moment(start).add(timeSlot.duration, "minutes"),
              patientGroupNames = map(timeSlot.patient_groups, (patientGroup) => {
                return sprintf("%s-%d", patientGroup.name, patientGroup.id);
              });
            let tenant_details = timeSlot.tenant_details || {};

            timeSlots.push({
              id: index,
              practitionerIds: timeSlot.practitioner_ids,
              title: startHour,
              url: "#",
              date: timeSlot.date,
              time: startHour,
              hour: start.format("HH"),
              minute: start.format("mm"),
              duration: timeSlot.duration,
              start: +start,
              startDateTime: start,
              end: +end,
              endDateTime: end,
              reservationsAllowed: timeSlot.reservations_allowed,
              autoAccept: timeSlot.auto_accept,
              patientGroups: timeSlot.patient_groups,
              patientGroupNames: patientGroupNames,
              externalDiary: tenant_details.external_diary,
              patientGroupClasses: map(patientGroupNames, (name) => {
                return "patient-group--" + name;
              }),
            });
          });

          resolve(timeSlots);
        })
        .fail(function (xhr) {
          if (xhr.status === 404) {
            resolve([]);
          } else {
            reject(xhr);
          }
        });
    });
  },
  _eventSort: function(a, b) {
    var delta = a.start - b.start;
    return delta == 0 ? a.end - b.end : delta;
  },
  /**
   * Loads and sorts the Event data using the TimeSlot loading function
   *
   * @private
   */
  _loadEvents: async function() {
    this.options.events = await this._loadTimeSlots(
      this.options.position.start,
      this.options.position.end
    )
    this.options.events.sort(this._eventSort);
    this.options.onAfterEventsLoad.call(this, this.options.events);
  },
  /**
   * Loads practitioner specific reasons for visit. Calls updateHeader to trigger populating reason select.
   *
   * @private
   */
  _loadReasons: function() {
    var self = this;
    self.options.reasons = [];
    if (self.options.practitionerIds) {
      var endpoint =
        "practitioner_reasonforvisit/?is_active=true&practitioner__practitioner_id__in=" +
        self.options.practitionerIds +
        "&brand=" +
        patientGroup;
    } else if (self.options.workplaceId) {
      // Fall back to getting reasons for practitioners in the workplace if there are no practitionerIds
      var endpoint =
        "practitioner_reasonforvisit/?is_active=true" +
        "&brand=" +
        patientGroup +
        "&brand_workplace=" +
        self.options.workplaceId;
    } else {
      self._updateHeader();
      return;
    }

    endpoint = `${endpoint}&practitioner__is_active=true`;

    let searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('reason_type')) {
      endpoint += `&reason_type=${searchParams.get('reason_type')}`;
    }
    if (searchParams.get('service')) {
      endpoint += `&reason_for_visit__id__in=${searchParams.get('service')}`;
    }

    return general.callApi(endpoint, "GET", null, null, (response) => {
      const removeDuplicatesAndSort = (rfvs) => {
        const get_rfv_display_name = (o) => { 
            return o.reason_for_visit.reason_display.toLowerCase().trim()
        }

        const sorted = rfvs.sort((cur, next) => {
            return get_rfv_display_name(cur) < get_rfv_display_name(next) ? -1 : 1
        })

        const unique = sorted.reduce((acc, cur) => {
            if (!acc.some(rfv => {
                return get_rfv_display_name(rfv) == get_rfv_display_name(cur)
            })) { acc.push(cur); }
            return acc;
        }, []);

        return unique;
      }

      self.options.reasons = removeDuplicatesAndSort(response.objects);
      if (
        !some(self.options.reasons, function(e) {
          return e.reason_for_visit.id == parseInt(self.options.reasonForVisitId);
        })
      ) {
        // This practitioner does not support the reason for visit the calendar is currently
        // set to(probably loaded from local storage). Reset it.
        self.options.reasonForVisitId = null;
        storage.sessionStorage.removeItem(this.options.reasonStorageKey);
      }
      self._updateHeader();
    });
  },
  /**
   * Sorts an array of Events into an object keyed from Monday (0) to Sunday (6)
   *
   * @param events
   * @returns {{0: Array, 1: Array, 2: Array, 3: Array, 4: Array, 5: Array, 6: Array}}
   */
  sortEvents: function(events) {
    var sortedEvents = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] },
      eventWindowStart = moment(this.options.position.start)
        .toDate()
        .getTime();
    forEach(events, (event) => {
      var eventStart = moment(event.start),
        time = eventStart.format("HH:mm"),
        day = Math.floor(
          (eventStart.toDate().getTime() - eventWindowStart) /
            1000 /
            60 /
            60 /
            24
        );
      if ($.isArray(sortedEvents[day])) sortedEvents[day].push(event);
      else if (typeof console !== "undefined") {
        console.error(
          template(
            "Unable to place Event <%- id %> with Date <%- date %> and Time <%- time %> in Week Calendar"
          )(event)
        );
      }
    });
    return sortedEvents;
  },
  /**
   *
   * @param date
   * @returns {*}
   */
  nextDate: function(date) {
    return moment(date).add(1, this.options.view);
  },
  /**
   *
   * @param date
   * @returns {*}
   */
  prevDate: function(date) {
    return moment(date).subtract(1, this.options.view);
  },
});
